import { Wifi, Coffee, ConciergeBell, UtensilsCrossed, Salad, WashingMachine, Bath, Pill, Wheat, Wheelchair, Plane, Scale, ParkingCircle } from 'lucide-react';
import { Snowflake } from 'lucide-react';
export default function AmenitiesGrid({ translate }) {

  const features = [
    { icon: <Wifi size={32} />, label: translate('amenities.wifi') },
    { icon: <UtensilsCrossed size={32} />, label: translate('amenities.cutlery') },
    { icon: <WashingMachine size={32} />, label: translate('amenities.washmachine') },
    { icon: <Bath size={32} />, label: translate('amenities.bath') },
    { icon: <ParkingCircle size={32} />, label: translate('amenities.parking') },
    { icon: <Snowflake size={32} />, label: translate('amenities.airConditioning') },

  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 text-center">
      {features.map((item, index) => (
        <div key={index} className="flex flex-col items-center text-sm text-purple-900">
          <div className="mb-2">{item.icon}</div>
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
